import Trial from './Trial'

const TrialContainer: React.FC = () => {
  return <Trial />
}

export default TrialContainer
